import { Stack } from '@/components/layout';
import { Button } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { PlayerPathwayImage } from '@/features/auth/components/player-pathway-image';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

type PlayerPathwayCardProps = {
  onTrackProgress?: () => void;
  hasActiveSession?: boolean;
};

export function PlayerPathwayCard({
  onTrackProgress,
  hasActiveSession = false,
}: PlayerPathwayCardProps) {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();
  const buttonLabel = hasActiveSession
    ? STRINGS.home.playerPathway.buttonResume
    : STRINGS.home.playerPathway.buttonTrack;

  return (
    <Stack width="100%" align="center" paddingX={scale(16)}>
      <Stack
        width="100%"
        maxWidth={scale({ phone: 339, tablet: 400 })}
        backgroundColor="white"
        borderTopLeftRadius={scale(2)}
        borderTopRightRadius={scale(2)}
        paddingTop={scale(72)}
        align="center">
        <PlayerPathwayImage />

        <Button onPress={onTrackProgress} style={styles.button}>
          <Button.Text
            style={styles.buttonText}
            variant={
              isTablet ? 'Font Inter/Subtitle/Medium 14px' : 'Font Inter/Subtitle/Regular 11px'
            }>
            {buttonLabel}
          </Button.Text>
        </Button>
      </Stack>
      <BottomLine />
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  button: {
    width: scale({ phone: 276, tablet: 240 }),
    height: scale({ phone: 32, tablet: 48 }),
    paddingVertical: scale(0),
    paddingHorizontal: scale(0),
    marginVertical: scale({ phone: 42, tablet: 33 }),
    borderRadius: scale(4),
  },
  buttonText: {
    textTransform: 'uppercase',
  },
}));

const BottomLine = () => {
  const { scale } = useScaling();
  return (
    <Stack
      width={scale({ phone: 339, tablet: 400 })}
      direction="row"
      backgroundColor={colors['Blue 2']}>
      <Stack width={scale(80)} height={scale(8)} backgroundColor={colors.Blue} />
    </Stack>
  );
};
